import React from 'react'

const Whatsapp = () => {
  return (
<>
  {/* Whatsapp Btn */}
  <a
        href="//api.whatsapp.com/send?phone=+918882449931&text"
        target="_blank"
        class="btn-whatsapp-pulse"
      >
     <i class="fa fa-whatsapp"></i>
       </a>
</>
  )
}

export default Whatsapp
